export const Globe = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 12C21 10.2191 20.4716 8.47817 19.4818 6.99767C18.4919 5.51718 17.085 4.36364 15.4393 3.68307C13.7935 3.00251 11.9829 2.82551 10.2365 3.17448C8.49005 3.52345 6.88645 4.38271 5.62861 5.64348C4.37078 6.90426 3.51528 8.50986 3.17038 10.2571C2.82549 12.0043 3.00672 13.8145 3.69113 15.4587C4.37554 17.1029 5.53236 18.507 7.01516 19.4934C8.49797 20.4798 10.2401 21.0041 12.021 21M3.6 8.99998H20.4M3.6 15H12.5"
      stroke="#5C5C5C"
      strokeWidth="1.69002"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4997 3C9.81501 5.69961 8.92188 8.81787 8.92188 12C8.92188 15.1821 9.81501 18.3004 11.4997 21M12.4997 3C14.4335 6.0978 15.3178 9.73619 15.0217 13.376M19.0007 21C18.4702 21 17.9615 20.7893 17.5865 20.4142C17.2114 20.0391 17.0007 19.5304 17.0007 19C17.0007 18.4696 17.2114 17.9609 17.5865 17.5858C17.9615 17.2107 18.4702 17 19.0007 17M19.0007 21C19.5311 21 20.0398 20.7893 20.4149 20.4142C20.79 20.0391 21.0007 19.5304 21.0007 19C21.0007 18.4696 20.79 17.9609 20.4149 17.5858C20.0398 17.2107 19.5311 17 19.0007 17M19.0007 21V22.5M19.0007 17V15.5M22.0317 17.25L20.7327 18M17.2697 20L15.9697 20.75M15.9697 17.25L17.2697 18M20.7327 20L22.0327 20.75"
      stroke="#5C5C5C"
      strokeWidth="1.69002"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
